import { useFormikContext } from "formik";
import React, { useContext, useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import KycApplicationContext from "../../../Context/KYCApplicationContext/KYCApplicationContext";
import { OptionsEnum } from "../../../Enumeration/OptionsEnum";
import UseFormikHelper from "../../../Utils/UseFormikHelper";
import CsplAchField from "../../CsplControls/CsplAch/CsplAchField";
import CsplRadioButtonField from "../../CsplControls/CsplRadioButton/CsplRadioButtonField";
import CsplTermsAndConditions from "../../CsplControls/CsplTermsAndConditions/CsplTermsAndConditions";

function AdditionalPersonalInfo() {
  const radioValueList = [OptionsEnum.Yes, OptionsEnum.No];
  const { values, setFieldValue } = useFormikContext();
  const applicationContext = useContext(KycApplicationContext);
  let isDisabled = applicationContext.disableForm;
  const { t } = useTranslation("common");
  const{clearFieldValue} = UseFormikHelper();
  const[checked,setChecked]=useState(false);

  const handleIsPep = (e) => {
    setFieldValue(e.target.name, e.target.value);
    if (e.target.value === OptionsEnum.No) {
      clearFieldValue(
        "personalInfoDTO.additionalPersonalInfoDTO.natureOfPoliticalExposued",
        null
      );
    }
  };

  const handleIsRelatedPep =(e) =>{
    setFieldValue(e.target.name, e.target.value);
    if (e.target.value === OptionsEnum.No) {
      clearFieldValue(
        "personalInfoDTO.additionalPersonalInfoDTO.relatedToPepNatureOfPoliticalExposued",
        null
      );
    }
  }
  function setTermsandConditionAcceptance (value){
    setChecked(value);
    setFieldValue("personalInfoDTO.additionalPersonalInfoDTO.additionalPersonalInfoTcAccepted",value);
    
  }
  useEffect(() => {
    // Initilise value
    if (values &&
      values.personalInfoDTO && values.personalInfoDTO.additionalPersonalInfoDTO && 
      values.personalInfoDTO.additionalPersonalInfoDTO.additionalPersonalInfoTcAccepted) {
      setChecked(values.personalInfoDTO.additionalPersonalInfoDTO.additionalPersonalInfoTcAccepted); 
    };
  }, []);


  return (
    <React.Fragment>
      {/*   <form className="form-group form_body"> */}

      <div className="content_body">
        <div className="row">
          {/* Overall width control */}

          <div className="col-lg-8 col-sm-11 col-12 mx-auto">
            {/* Two Column Approach */}

            <div className="col-sm-11 col-12 mb-4 me-auto">
              <div className="d-md-flex justify-content-between">
                <div className="w-100 me-3 mb-md-0 mb-sm-4 mb-4">
                  <CsplAchField
                    label={"additionalPersonalInfo.occupationType"}
                    name="personalInfoDTO.additionalPersonalInfoDTO.occupationType"
                    required={true}
                    lookupName="occupationType"
                    displayColumn="name"
                    idColumn="id"
                    id="occupationType"
                    disabled={isDisabled}
                  />
                </div>
                <div className="w-100">
                  <CsplAchField
                    label={"additionalPersonalInfo.educationalQualifications"}
                    name="personalInfoDTO.additionalPersonalInfoDTO.educationalQualification"
                    required={true}
                    lookupName="educationalQualifications"
                    displayColumn="name"
                    idColumn="id"
                    id="educationalQualification"
                    disabled={isDisabled}
                  />
                </div>
              </div>
            </div>

            {/* One Column Approach */}

            <div className="col-sm-11 col-12 mb-4 me-auto">
              <div className="d-md-flex justify-content-between">
                <div className="w-100 me-3 mb-md-0 mb-sm-4 mb-4">
                  <CsplAchField
                    label={"additionalPersonalInfo.incomeLevel"}
                    name="personalInfoDTO.additionalPersonalInfoDTO.incomeLevel"
                    required={true}
                    lookupName="incomeLevel"
                    displayColumn="name"
                    idColumn="id"
                    id="incomeLevel"
                    disabled={isDisabled}
                  />
                </div>
                <div className="w-100"></div>
              </div>
            </div>

            {/* Two Column Approach */}

            <div className="col-sm-11 col-12 mb-4 me-auto">
              <div className="d-md-flex justify-content-between">
                <div className="w-100 me-3 mb-md-0 mb-sm-4 mb-4">
                  <CsplRadioButtonField
                    valuelist={radioValueList}
                    disabled={isDisabled}
                    rowdisplay={true}
                    label={"additionalPersonalInfo.areYouaPep"}
                    name="personalInfoDTO.additionalPersonalInfoDTO.politicallyExposed"
                    onChange={handleIsPep}
                    defaultValue={OptionsEnum.No}
                    tooltip ={"additionalPersonalInfo.areYouPepInfo"}
                    tooltipplace={"left"}
                  ></CsplRadioButtonField>
                </div>
                {values &&
                  values.personalInfoDTO &&
                  values.personalInfoDTO.additionalPersonalInfoDTO &&
                  values.personalInfoDTO.additionalPersonalInfoDTO
                    .politicallyExposed &&
                  values.personalInfoDTO.additionalPersonalInfoDTO
                    .politicallyExposed === OptionsEnum.Yes && (
                    <div className="w-100 mt-md-2">
                      <CsplAchField
                        label={"additionalPersonalInfo.natureOfExposure"}
                        name="personalInfoDTO.additionalPersonalInfoDTO.natureOfPoliticalExposued"
                        required={true}
                        lookupName="natureOfExposure"
                        displayColumn="name"
                        idColumn="id"
                        id="natureOfExposure"
                        disabled={isDisabled}
                      />
                    </div>
                  )}
              </div>
            </div>

            {/* Two Column Approach */}

            <div className="col-sm-11 col-12 mb-2 me-auto">
              <div className="d-md-flex justify-content-between">
                <div className="w-100 me-3 mb-md-0 mb-sm-4 mb-4">
                  <CsplRadioButtonField
                    valuelist={radioValueList}
                    disabled={isDisabled}
                    rowdisplay={true}
                    label={"additionalPersonalInfo.areYouRelatedToPep"}
                    name="personalInfoDTO.additionalPersonalInfoDTO.relatedPoliticallyExposed"
                    defaultValue={OptionsEnum.No}
                    onChange={handleIsRelatedPep}
                    tooltip = {"additionalPersonalInfo.areYouRelatedToPepInfo"}
                    tooltipplace={"left"}
                  ></CsplRadioButtonField>
                </div>
                {values &&
                  values.personalInfoDTO &&
                  values.personalInfoDTO.additionalPersonalInfoDTO &&
                  values.personalInfoDTO.additionalPersonalInfoDTO
                    .relatedPoliticallyExposed &&
                  values.personalInfoDTO.additionalPersonalInfoDTO
                    .relatedPoliticallyExposed === OptionsEnum.Yes && (
                    <div className="w-100 mt-md-2">
                      <CsplAchField
                        label={"additionalPersonalInfo.natureOfExposure"}
                        name="personalInfoDTO.additionalPersonalInfoDTO.relatedToPepNatureOfPoliticalExposued"
                        required={true}
                        lookupName="relatedToPepPoliticalExposure"
                        displayColumn="name"
                        idColumn="id"
                        id="natureOfExposureforRelatedPep"
                        disabled={isDisabled}
                      />
                    </div>
                  )}
              </div>
            </div>

            <div className="col-sm-11 col-12  me-auto">
              {
                <div className="modal_KycGuide padding-bottom-25 ">
                  <CsplTermsAndConditions
                    description={
                      <>{t("additionalPersonalInfo.TermsAndConditionsText")}</>
                    }
                    disabled={isDisabled}
                    name="personalInfoDTO.additionalPersonalInfoDTO.additionalPersonalInfoTcAccepted"
                    label={"termsAndCondition.agreeTermsAndConditionText"}
                    showlinktext={false}
                  ></CsplTermsAndConditions>
                </div>
              }
            </div>
            <div className="col-sm-11 w-100 me-3 mb-4">&nbsp;</div>
            <div className="col-sm-11 w-100 me-3 mb-4">&nbsp;</div>
          </div>
        </div>
      </div>

      {/*  </form> */}
    </React.Fragment>
  );
}

export default AdditionalPersonalInfo;
